<template>
  <div>
    <Toast></Toast>
    <div class="row">
      <div class="col-12">
        <form class="floating-labels" onsubmit="return false">
          <div class="row">
            <div class="col-2" 
            v-if="called_by == 'PaymentRequest_1'">
              <div class="form-group">
                <span class="p-float-label">
                <MultiSelect
                style="width: 200px"
                v-model="selectedList"
                :options="statusList"
                optionLabel="name"
                placeholder="Search By Status"
                display="chip"
                @change="applyDateClick()"
              /> 
                </span>
              </div>
            </div>
            <div
              class="col-1"
              v-if="
                called_by !== 'LobbyDisplay' && called_by !== 'PaymentRequest'
              "
            >
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.veinsId"
                    @keypress="isSpecialSymbol($event)" 
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">Veins ID</label>
                </span>
              </div>
            </div>
            <div class="col-1" v-if="called_by !== 'LobbyDisplay' && called_by !== 'PaymentRequest'">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.externalid"
                    @change="applyDateClick()"
                    style="width: 100%"
                    @keypress="isSpecialSymbol($event)" 
                  />
                  <label id="font1">External ID</label>
                </span>
              </div>
            </div>

            <div class="col-2" v-if="called_by !== 'PaymentRequest'">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    @keypress="isSpecialSymbol($event)" 
                    placeholder=""
                    maxlength="50"
                    v-model="filter.firstname"
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">Search By First Name</label>
                </span>
              </div>
            </div>
            <div class="col-2" v-if="called_by !== 'PaymentRequest'">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    maxlength="50"
                    v-model="filter.lastname"
                    @keypress="isSpecialSymbol($event)" 
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">Search By Last Name</label>
                </span>
              </div>
            </div>
             <div class="col-2" v-if="called_by === 'VeinCheckInModal' || called_by === 'PatientPortal'">
              <div class="form-group">
                <label style="margin-top:-22px;">DOB</label>
                <InputText
                  type="date"
                  class="form-control"
                  id="dob"
                  v-model="filter.Dob"
                  @change="applyDateClick()"
                />
              </div>
            </div>
            <div class="col-2" v-if="called_by !== 'LobbyDisplay' && called_by !== 'PaymentRequest' && called_by !== 'PaymentRequest_1'">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    v-mask="'###-###-####'"
                    type="tel"
                    id=""
                    placeholder=""
                    v-model="filter.phone"
                    @change="applyDateClick()"
                      @keypress="isSpecialSymbol($event)" 
                    style="width: 100%"
                  />
                  
                  <label id="font1">Search By Phone</label>
                </span>
              </div>
            </div>
               <!-- <div class="col-1" v-if="called_by === 'VeinCheckInModal'">
              <Button
                style="width: 188px;margin-left: -17px;"
                type="button"
                icon="pi pi-search"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
              >
                {{ currentDateRange }}
              </Button>
              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="false"
                id="overlay_panel"
                :breakpoints="{ '960px': '75vw' }"
              >
                <Menu id="overlay_menu" ref="menu" :model="dateMenu" />
                <Inplace :closable="true">
                  <template #display>
                    <div style="margin-left: 25px">Custom Range</div>
                  </template>
                  <template #content>
                    <label for="searchrange">Custom Range</label>
                    <Calendar
                      id="searchrange"
                      v-model="sdate"
                      selectionMode="range"
                      :manualInput="false"
                      :showButtonBar="true"
                    />
                  </template>
                </Inplace>
                <Divider />
                <Button
                  label="Apply"
                  class="p-button-primary"
                  style="margin-right: 5px"
                  @click="applyDateClick()"
                />
                <Button
                  label="Cancel"
                  class="p-button-outlined p-button-info"
                  @click="toggle"
                />
              </OverlayPanel> -->
              <!-- </div> -->
            <!-- </div> -->
            <div class="col-2" v-if="called_by === 'VeinCheckInModal'" style="margin-left:-1px;">
              <a
                class="btn btn-success"
                style="float:right;"
                @click="clearSearchFields()"
              >
                Clear
              </a>
              <a
                class="btn btn-success"
                style="float:right;margin-right:10px;"
                @click="applySearchClick()"
              >
                Search
              </a>
            </div>
            <div class="col-2" v-if="called_by !== 'VeinCheckInModal' && called_by !== 'PatientPortal'">
              <Button
                style="width: 120%;"
                type="button"
                icon="pi pi-search"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
              >
                {{ currentDateRange }}
              </Button>
              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="false"
                id="overlay_panel"
                :breakpoints="{ '960px': '75vw' }"
              >
                <Menu id="overlay_menu" ref="menu" :model="dateMenu" />
                <Inplace :closable="true">
                  <template #display>
                    <div style="margin-left: 25px">Custom Range</div>
                  </template>
                  <template #content>
                    <label for="searchrange">Custom Range</label>
                    <Calendar
                      id="searchrange"
                      v-model="sdate"
                      selectionMode="range"
                      :manualInput="false"
                      :showButtonBar="true"
                    />
                  </template>
                </Inplace>
                <Divider />
                <Button
                  label="Apply"
                  class="p-button-primary"
                  style="margin-right: 5px"
                  @click="applyDateClick()"
                />
                <Button
                  label="Cancel"
                  class="p-button-outlined p-button-info"
                  @click="toggle"
                />
              </OverlayPanel>
              <!-- </div> -->
            </div>
            <div class="col-2" v-if="called_by !== 'VeinCheckInModal'">
              <a
                class="btn btn-success"
                style="float:right;"
                @click="clearSearchFields()"
              >
                Clear
              </a>
              <a
                class="btn btn-success"
                style="float:right;margin-right:10px;"
                @click="applySearchClick()"
              >
                Search
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script src='./jsfiles/PatientsSearchComponent.js'></script><style></style>
